function Switch({switchValue, setSwitchValue, text}:{switchValue:boolean, setSwitchValue:any, text?:string}) {

  return ( 
    <div className="flex items-center gap-3">

    
  <div onClick={()=> setSwitchValue(!switchValue)} className={` w-12 h-6 border-2 border-primary bg-gray-200 rounded-sm overflow-hidden flex`}>
    <div className={`${switchValue ? "translate-x-full bg-primary": "bg-black"}  w-1/2  h-full transition-all`}></div>
    {/* <div className="w-1/2 bg-gray-200 h-full"></div> */}
  </div> 
<div>
  {text}
</div>
  </div>);
}

export default Switch;